import { render } from "./SelectComponentGrupos.vue?vue&type=template&id=dbf4c86c&scoped=true"
import script from "./SelectComponentGrupos.vue?vue&type=script&lang=js"
export * from "./SelectComponentGrupos.vue?vue&type=script&lang=js"

import "./SelectComponentGrupos.vue?vue&type=style&index=0&id=dbf4c86c&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbf4c86c"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
